import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';

/**
 * Returns sets of field/display keys that should be hidden in the printing
 * proposal editor based on feature toggles and dealer settings. Only relevant
 * for printing proposals — 4-square proposals bypass these toggles entirely
 * and should not call this hook.
 */
export const useHiddenProposalKeys = () => {
    const isConditionalDiscountDisplayEnabled = useSelector(featureToggleSelectors.isConditionalDiscountDisplayEnabled);
    const isTradeEvaluationReconCostMVPrintingEnabled = useSelector(
        featureToggleSelectors.isTradeEvaluationReconCostMVPrintingEnabled
    );
    const isCarsActDisclosuresApplicable = useSelector(dealerSelectors.isCarsActDisclosuresApplicable);
    const isPriorBalanceEnabled = useSelector(featureToggleSelectors.isPriorBalanceEnabled);

    const hiddenFieldKeys = useMemo(() => {
        const hidden = new Set<string>();
        if (!isCarsActDisclosuresApplicable) hidden.add('totalOfPaymentsAndConsideration');
        if (!isPriorBalanceEnabled) hidden.add('priorBalance');
        return hidden;
    }, [isCarsActDisclosuresApplicable, isPriorBalanceEnabled]);

    const hiddenDisplayKeys = useMemo(() => {
        const hidden = new Set<string>();
        if (!isConditionalDiscountDisplayEnabled) hidden.add('conditionalDiscount');
        if (!isTradeEvaluationReconCostMVPrintingEnabled) hidden.add('tradeEvaluation');
        if (!isCarsActDisclosuresApplicable) hidden.add('carsActSpanishDisclosure');
        return hidden;
    }, [isConditionalDiscountDisplayEnabled, isTradeEvaluationReconCostMVPrintingEnabled, isCarsActDisclosuresApplicable]);

    return { hiddenFieldKeys, hiddenDisplayKeys };
};
